export default __webpack_public_path__ + "static/media/php.5e553a43.svg";